const COUNT_LINES = 5;

class ShowMore {
	constructor(el) {
		this.el = el;

		if (!this.el) return;

		this.text = this.el.querySelector('.show-more__text');
		this.button = this.el.querySelector('.show-more__button');

		this.init();
	}

	init() {
		this.updateCollapsedHeight();

		const isOverflow = this.text.scrollHeight > this.collapsedHeight + 1.5;

		if (!isOverflow) {
			this.button.style.display = 'none';
			this.text.style.maxHeight = 'none';
			this.el.classList.add('_no-more');
			return;
		}

		this.text.style.maxHeight = `${this.collapsedHeight}px`;
		this.text.style.transition = 'max-height 0.15s ease-in-out';

		this.button.addEventListener('click', () => this.toggle());
		window.addEventListener('resize', () => this.onResize());
	}

	updateCollapsedHeight() {
		this.collapsedHeight = parseFloat(getComputedStyle(this.text).lineHeight) * COUNT_LINES;
	}

	onResize() {
		clearTimeout(this.resizeTimeout);
		this.resizeTimeout = setTimeout(() => {
			this.updateCollapsedHeight();
			const isOverflow = this.text.scrollHeight > this.collapsedHeight + 1.5;

			if (isOverflow) {
				this.button.style.display = '';
				this.el.classList.remove('_no-more');
			} else {
				this.button.style.display = 'none';
				this.text.style.maxHeight = 'none';
				this.el.classList.remove('_is-open');
				this.el.classList.add('_no-more');
				return;
			}

			if (!this.el.classList.contains('_is-open')) {
				this.text.style.maxHeight = `${this.collapsedHeight}px`;
			} else {
				this.text.style.maxHeight = `${this.text.scrollHeight}px`;
			}
		}, 300);
	}

	toggle() {
		const isOpen = this.el.classList.contains('_is-open');

		this.text.classList.add('_is-animating');

		if (isOpen) {
			this.text.style.maxHeight = `${this.text.scrollHeight}px`;
			requestAnimationFrame(() => {
				this.text.style.maxHeight = `${this.collapsedHeight}px`;
				this.el.classList.remove('_is-open');
				this.button.innerHTML = '<span>Ещё</span>';
			});
		} else {
			this.text.style.maxHeight = `${this.text.scrollHeight}px`;
			this.el.classList.add('_is-open');
			this.button.innerHTML = '<span>Свернуть</span>';
		}

		this.text.addEventListener(
			'transitionend',
			() => {
				this.text.classList.remove('_is-animating');
			},
			{ once: true },
		);
	}
}

document.querySelectorAll('[data-show-more]').forEach((el) => new ShowMore(el));
export default ShowMore;
